import { BehaviorSubject } from "rxjs";

const create$ = (store) => {
  const state$ = new BehaviorSubject(store.getState());
  store.subscribe(() => {
    state$.next(store.getState());
  });
  return state$;
};

export default create$;